(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mupiko-image-comparison')) {
    customElements.define('mupiko-image-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const frame = this.querySelector('[data-comparison-frame]');
        const range = this.querySelector('input[type="range"]');
        if (!frame || !range) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        let activePointer = null;
        const update = value => {
          const position = Math.min(100, Math.max(0, Math.round(Number(value) || 0)));
          range.value = String(position);
          this.style.setProperty('--comparison-position', position + '%');
          range.setAttribute('aria-valuetext', range.dataset.beforeLabel + ' %' + position + ', ' + range.dataset.afterLabel + ' %' + (100 - position));
          this.querySelector('.image-comparison__label--before').hidden = position === 0;
          this.querySelector('.image-comparison__label--after').hidden = position === 100;
        };
        const updatePointer = event => {
          const bounds = frame.getBoundingClientRect();
          if (bounds.width) update((event.clientX - bounds.left) / bounds.width * 100);
        };
        range.addEventListener('input', () => update(range.value), options);
        range.addEventListener('change', () => update(range.value), options);
        frame.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || event.target === range) return;
          if (event.pointerType !== 'touch') event.preventDefault();
          activePointer = event.pointerId;
          range.focus({ preventScroll: true });
          frame.setPointerCapture(activePointer);
          updatePointer(event);
        }, options);
        frame.addEventListener('pointermove', event => {
          if (event.pointerId === activePointer) updatePointer(event);
        }, options);
        const finish = event => {
          if (event.pointerId !== activePointer) return;
          if (event.type === 'pointerup') updatePointer(event);
          activePointer = null;
          if (frame.hasPointerCapture(event.pointerId)) frame.releasePointerCapture(event.pointerId);
        };
        frame.addEventListener('pointerup', finish, options);
        frame.addEventListener('pointercancel', finish, options);
        frame.addEventListener('lostpointercapture', () => { activePointer = null; }, options);
        update(range.value);
        range.hidden = false;
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
